module.exports = __webpack_public_path__ + "img/not-authorized.a873e255.png";